<template>
  <div>
    <div
      id="setting-container">
      <b-row>
        <b-col cols="12">
          <h3>LABEL</h3>
        </b-col>
      </b-row>
      <br>
    </div>
  </div>
</template>

<script>

// import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardLabelTab',
  components: {

  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {


  },
  created() {

  },

  methods: {

  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/board/tabs/jBoardLabelTab.vue